<script>
	import { Col } from "sveltestrap";
	import CustomButton from "../../../components/CustomButton/CustomButton.svelte";

	export let handleExportCSV;
	export let toggleCsvImport;
	export let fillFiles;
</script>

<Col class="d-flex flex-row-reverse">
	<div class="mx-2">
		<CustomButton
			onClick={() => handleExportCSV(0)}
			buttonText="Export CSV"
		/>
	</div>
	<div class="mx-2">
		<input
			id="fileInput"
			type="file"
			accept=".csv, text/csv"
			multiple={false}
			hidden="hidden"
			on:change={(e) => {
				fillFiles(e);
				toggleCsvImport();
			}}
		/>
		<label
			type="button"
			for="fileInput"
			id="customButton"
			class="fds-button btn btn-secondary"
			block>Upload Jobs</label
		>
		<span>
			<a
				href="/assets/csv/Jobs_Template.csv"
				target="_blank"
				download="jobs_template.csv"
				rel="noreferrer"
				class="link link-text"
			>
				Download CSV Template
			</a>
		</span>
	</div>
</Col>
